const translations = {
    americanAutonomy: 'American Autonomy'
};

export default translations;
